import { useMemo } from 'react'
import { useSafeRouter } from '@/utils/nextUtils/safe-router'

export type PlayerType = 'bitmovin' | 'hlsjs'

const PLAYER_QUERY_PARAM = 'player'
const VALID_PLAYER_TYPES: ReadonlySet<string> = new Set<PlayerType>(['bitmovin', 'hlsjs'])

/**
 * Centralized hook for determining which video player implementation to use.
 *
 * Priority order:
 * 1. Query param `?player=hlsjs` or `?player=bitmovin`
 * 2. TODO: GrowthBook experiment (not yet created)
 * 3. Default: 'bitmovin'
 */
export function usePlayerPreference(): PlayerType {
  const { query } = useSafeRouter()

  return useMemo(() => {
    const queryValue = query[PLAYER_QUERY_PARAM]
    if (typeof queryValue === 'string' && VALID_PLAYER_TYPES.has(queryValue)) {
      return queryValue as PlayerType
    }

    // TODO: [WEB-5071] Check GrowthBook experiment value here once the experiment is created.
    // Example:
    // const [playerExperiment] = useGBExperiment('hlsjs-player', 'bitmovin')
    // if (VALID_PLAYER_TYPES.has(playerExperiment)) return playerExperiment as PlayerType

    return 'bitmovin'
  }, [query])
}
